import WorksheetForm from '~/features/projectWizard/worksheets/common/components/WorksheetForm';
import ItcAddersForm from './ItcAddersForm';
import ExpectedITCPercentage from './ExpectedITCPercentage';
import UpfrontIncentives from './UpfrontIncentives';
import { WorksheetField } from '~/features/projectWizard/worksheets/common/components/Field';
import { useProjectContext } from '~/hooks';
import './styles.scss';

export default function SourceOfFunds() {
  const { project } = useProjectContext();
  return (
    <WorksheetForm>
      <div className="card worksheet-section-itc">
        <WorksheetField
          type="radio"
          fieldLabel="Is the project expected to be ITC eligible?"
          schemaKey="itcDetails.isItcEligible"
          values={[
            { label: 'Yes', value: true },
            { label: 'No', value: false },
          ]}
          inline
        />
        {project?.itcDetails?.isItcEligible ? (
          <>
            <ItcAddersForm />
            <ExpectedITCPercentage />

            <WorksheetField
              type="radio"
              fieldLabel="Have you safe harbored this project for ITC eligibility?"
              schemaKey="itcDetails.safeHarboredForItc"
              values={[
                { label: 'Yes', value: true },
                { label: 'No', value: false },
              ]}
              inline
            />

            {project?.itcDetails?.safeHarboredForItc === true ? (
              <>
                <WorksheetField
                  type="dropdown"
                  multiple
                  placeholder="Select all that apply..."
                  fieldLabel="How is this safe harbored for the ITC?"
                  schemaKey="itcDetails.itcSafeHarborStrategy"
                  options={[
                    { text: 'Met the 5% spend test (Project <1.5MWac)', value: 'spend_test_small' },
                    { text: 'Met the 5% spend test before 9/2/25 (Project >1.5MWac)', value: 'spend_test_large' },
                    { text: 'Construction started via onsite physical work', value: 'construction_onsite' },
                    { text: 'Construction started via offsite physical work', value: 'construction_offsite' },
                    { text: 'N/A - BESS project only', value: 'na_bess_only' },
                  ]}
                />
                <WorksheetField
                  type="textarea"
                  fieldLabel="ITC safe harbor details"
                  helpText="Describe the supporting information behind the above checked boxes, including any equipment procured with manufacturer details and dates for which each activity was completed."
                  schemaKey="itcDetails.itcSafeHarborDetails"
                  placeholder="Type here..."
                />
              </>
            ) : project?.itcDetails?.safeHarboredForItc === false ? (
              <>
                <WorksheetField
                  type="dropdown"
                  multiple
                  placeholder="Select all that apply..."
                  fieldLabel="How will this qualify for the ITC?"
                  schemaKey="itcDetails.otherItcQualifications"
                  options={[
                    { text: 'Placed in service prior to 12/31/27', value: 'placed_in_service' },
                    { text: '5% of project budget spent before 7/5/26 (Project <1.5MWac)', value: 'spend_test_small_safe_harbor' },
                    { text: 'Construction start via onsite physical work before 7/5/26', value: 'construction_onsite_safe_harbor' },
                    { text: 'Construction start via offsite physical work before 7/5/26', value: 'construction_offsite_safe_harbor' },
                  ]}
                />
                <WorksheetField
                  type="textarea"
                  fieldLabel="Expected ITC compliance details"
                  helpText="Describe the plan supporting the above selected items, including target dates and strategies."
                  schemaKey="itcDetails.otherItcDetails"
                  placeholder="Type here..."
                />
                <WorksheetField
                  type="dropdown"
                  placeholder="Select one..."
                  fieldLabel="Is your company planning to take these actions directly, or do you need to align with an investor first?"
                  schemaKey="itcDetails.additionalNotes"
                  options={[
                    { text: 'We can do this and we will.', value: 'We can do this and we will.' },
                    { text: 'We can do this but we prefer to align with an investor first.', value: 'We can do this but we prefer to align with an investor first.' },
                    { text: 'We cannot do this and need to align with an investor first.', value: 'We cannot do this and need to align with an investor first.' },
                  ]}
                />
              </>
            ) : null} 

            <WorksheetField
              type="radio"
              fieldLabel="Have you safe harbored this project for FEOC compliance?"
              schemaKey="itcDetails.safeHarboredForFeoc"
              values={[
                { label: 'Yes', value: true },
                { label: 'No', value: false },
              ]}
              inline
            />

            {project?.itcDetails?.safeHarboredForFeoc === true ? (
              <>
                <WorksheetField
                  type="dropdown"
                  multiple
                  placeholder="Select all that apply..."
                  fieldLabel="How is this safe harbored from FEOC?"
                  schemaKey="itcDetails.feocSafeHarborStrategy"
                  options={[
                    { text: 'Met the 5% spend test before 1/1/26', value: 'spend_test_before_2026' },
                    { text: 'Construction started via onsite physical work before 1/1/26', value: 'construction_onsite_before_2026' },
                    { text: 'Construction started via offsite physical work before 1/1/26', value: 'construction_offsite_before_2026' },
                  ]}
                />
                <WorksheetField
                  type="textarea"
                  fieldLabel="FEOC safe harbor details"
                  helpText="Describe the supporting information behind the above checked boxes, including any equipment procured with manufacturer details and dates for which each activity was completed."
                  schemaKey="itcDetails.feocSafeHarborDetails"
                  placeholder="Type here..."
                />
              </>
            ) : project?.itcDetails?.safeHarboredForFeoc === false ? (
              <WorksheetField
                type="textarea"
                fieldLabel="FEOC compliance details"
                helpText="Describe your FEOC compliance strategy, including targeted qualifying equipment"
                schemaKey="itcDetails.feocComplianceDetails"
                placeholder="Type here..."
              />
            ) : null}

          </>
        ) : null}
      </div>
      <UpfrontIncentives />
    </WorksheetForm>
  );
}